import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { flashMessage as flash } from "./../../../utils/flash/index";
import lifecoverService from "./lifecoverService";

const initialState = {
  all_life_cover: [],
  single_life_cover: null,
  unpaginated_life_cover: [],
  isLoading: false,
  isSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  isUpdating: false,
  isError: false,
};

const lifeCoverSlice = createSlice({
  initialState,
  name: "lifecover",
  reducers: {
    resetLifeCover: (state) => initialState,
    resetLifeCoverStatus: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.single_life_cover = null;
      state.createSuccess = false;
      state.updateSuccess = false;
      state.isFetching = false;
    },
    resetUpdateLifeCover: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLifeCover.pending, (state) => {
        state.isLoading = true;
        flash("info", "Life Cover is creating...");
      })
      .addCase(createLifeCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.createSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(createLifeCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(updateLifeCover.pending, (state) => {
        state.isLoading = true;
        flash("info", "Life Cover is updating...");
      })
      .addCase(updateLifeCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.updateSuccess = true;
          flash("success", payload.message);
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateLifeCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(getAllLifeCover.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllLifeCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.all_life_cover = payload;
          state.unpaginated_life_cover = payload.life_cover_policy
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getAllLifeCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      // .addCase(getUnpaginatedLifeCover.pending, (state) => {
      //   state.isLoading = true;
      // })
      // .addCase(getUnpaginatedLifeCover.fulfilled, (state, { payload }) => {
      //   state.isLoading = false;
      //   if (!payload.errors) {
      //     state.unpaginated_life_cover = payload;
      //   } else if (typeof payload.errors == "string") {
      //     flash("error", payload.errors);
      //   } else {
      //     let key = Object.keys(payload.errors)[0];
      //     let message = payload.errors[key][0];
      //     flash("error", message);
      //   }
      // })
      // .addCase(getUnpaginatedLifeCover.rejected, (state, action) => {
      //   state.isLoading = false;
      //   state.isError = true;
      // })
      .addCase(getSingleLifeCover.pending, (state) => {
        state.isLoading = true;
        state.single_life_cover = null;
      })
      .addCase(getSingleLifeCover.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (!payload.errors) {
          state.isSuccess = true;
          state.single_life_cover = payload.data;
        } else if (typeof payload.errors == "string") {
          flash("error", payload.errors);
        } else {
          let key = Object.keys(payload.errors)[0];
          let message = payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(getSingleLifeCover.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const createLifeCover = createAsyncThunk(
  "/charge/create",
  async (data, thunkAPI) => {
    try {
      return await lifecoverService.createLifeCover(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllLifeCover = createAsyncThunk(
  "/charge/getAll",
  async (data, thunkAPI) => {
    try {
      return await lifecoverService.getAllLifeCover(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// export const getUnpaginatedLifeCover = createAsyncThunk(
//   "/charge/getUnpaginated",
//   async (_, thunkAPI) => {
//     try {
//       return await lifecoverService.getUnpaginatedLifeCover();
//     } catch (error) {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();
//       return thunkAPI.rejectWithValue(message);
//     }
//   }
// );

export const getSingleLifeCover = createAsyncThunk(
  "/charge/getSingle",
  async (id, thunkAPI) => {
    try {
      return await lifecoverService.getSingleLifeCover(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateLifeCover = createAsyncThunk(
  "/charge/update",
  async (id, thunkAPI) => {
    try {
      return await lifecoverService.updateLifeCover(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const { resetLifeCover, resetLifeCoverStatus, resetUpdateLifeCover } =
  lifeCoverSlice.actions;
export default lifeCoverSlice.reducer;
